import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
export function makePdfLegalTerms(data) {
    let idGenerator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : generateUniqueId;
    return _object_spread_props(_object_spread({}, data), {
        contentType: 'pdf',
        origin: 'custom',
        id: data.id || idGenerator('tos')
    });
}
export function makeRichTextLegalTerms(data) {
    let idGenerator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : generateUniqueId;
    return _object_spread_props(_object_spread({}, data), {
        contentType: 'richText',
        origin: 'system',
        id: data.id || idGenerator('tos')
    });
}
export function makeQuillLegalTerms(data) {
    let idGenerator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : generateUniqueId;
    return {
        id: data.id || idGenerator('tos'),
        name: data.name,
        contentType: 'quill',
        origin: data.origin,
        richTextContent: data.richTextContent,
        richTextId: data.richTextId,
        usedIn: data.usedIn
    };
}
